import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datoservicios',
  templateUrl: './datoservicios.component.html',
  styleUrls: ['./datoservicios.component.scss']
})
export class DatoserviciosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  } 

}
